import { render, staticRenderFns } from "./DetailTerm.vue?vue&type=template&id=07a4f606&scoped=true&"
import script from "./DetailTerm.vue?vue&type=script&lang=js&"
export * from "./DetailTerm.vue?vue&type=script&lang=js&"
import style0 from "./DetailTerm.vue?vue&type=style&index=0&id=07a4f606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4f606",
  null
  
)

export default component.exports